module.exports = __webpack_public_path__ + "static/media/29.44860fd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/29.svg
// module id = 400
// module chunks = 14